import store from '@shared/store'
import $http from '@shared/module/axios'
import i18n from '@shared/module/i18n'

const TOKEN_KEY = 'session'

export async function saveUserSession() {
    if (localStorage.length === 0) {
        return {}
    }
    const session = {}
    for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i)
        session[key] = localStorage.getItem(key)
    }
    return $http.post('/api/session/', session)
        .then(r => { return { [TOKEN_KEY]: r.data.sessionId } })
        .catch(() => { return {} })
}

export async function restoreUserSession() {
    const params = new URLSearchParams(window.location.search)
    if (params.has(TOKEN_KEY)) {
        try {
            const response = await $http.get(`/api/session/${params.get(TOKEN_KEY)}`)
            const session = response.data
            if (typeof session !== 'object') {
                return
            }
            Object.entries(session).forEach(([key, value]) => {
                localStorage.setItem(key, value.toString())
            })

            const locale = localStorage.getItem('locale')
            if (locale) {
                i18n.locale = locale
                store.setLocale(locale)
            }

            const user = localStorage.getItem('currentUser')
            if (user) {
                store.setCurrentUser(JSON.parse(user))
            }
        } catch (e) {
            console.error('Invalid session:', e.message)
        }
    }
}
